import { render } from "./ModalConnectVTP.vue?vue&type=template&id=0f31cf0b"
import script from "./ModalConnectVTP.vue?vue&type=script&lang=js"
export * from "./ModalConnectVTP.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__